module.exports = __webpack_public_path__ + "static/media/Inconsolata-Bold.55421b06.ttf";